import { Spacer, useModal, AsButton, Modal } from '@adserve/adserve-react-components';
import React, { useEffect, useState } from 'react';
import { GetReservationTimes } from '../../../services/CampaignsDataService';
import {
    CreateCampaignProperty,
    GetCampaignProperties,
    ReserveCampaignProperty,
    DeleteCampaignProperty
} from '../../../services/DataService';
import { pageContainerStyle } from '../CampaignStyles';
import CampaignPropertiesPanel from './CampaignPropertiesPanel';
import RequestDialog from './RequestDialog';
import ShowPanel from './ShowPanel';
import ShowPropertiesPanel from './ShowPropertiesPanel';
import CreatePropertyOrders from './CreatePropertyOrders';

const PropertySelection = ({ campaign, getCampaign, readOnly = false }) => {
    const [campaignProperties, setCampaignProperties] = useState([]);
    const [reservationTimes, setReservationTimes] = useState([]);
    const [selectedShow, setSelectedShow] = useState();
    const [addingShow, setAddingShow] = useState(false);

    const { addMessage, removeMessage } = useModal();

    const loadCampaignProperties = async () => {
        await GetCampaignProperties(campaign.id).then((data) => {
            campaign.campaignProperties = data;
            setCampaignProperties(data);
        });
    };

    const loadReservationTimes = () => {
        GetReservationTimes({ pageNumber: 1, pageSize: -1 }).then((res) => {
            setReservationTimes(res.filter((rt, i) => rt.hasOwnProperty('id')));
        });
    };

    useEffect(() => {
        setCampaignProperties(campaign.campaignProperties);
        loadReservationTimes();
    }, [campaign]);
    const [isReserving, setIsReserving] = useState(false);
    const handleReserve = (request) => {
        const propertyRequestObject = {
            propertyId: request.property.id,
            campaignId: campaign.id,
            reservationPrice: request.reservationPrice,
            requestNotes: request.note
        };

        CreateCampaignProperty(propertyRequestObject).then(() => {
            loadCampaignProperties();
        });

        //setIsReserving(true)
        /*  ReserveCampaignProperty(request).then(() => {
            addMessage({
                message: window.translate('Quote created'),
                buttons: [{ text: window.translate('Ok') }]
            });
            loadCampaignProperties();
            getCampaign(campaign.id);
        });
        */
    };

    const onSelectShowClick = (show) => {
        setSelectedShow(show);
        setAddingShow(true);
    };
    const [isQuoting, setIsQuoting] = useState({});
    const handleRequestClick = (val) => {
        const propertyRequestObject = {
            propertyId: val.id,
            campaignId: campaign.id
        };

        CreateCampaignProperty(propertyRequestObject).then(() => {
            loadCampaignProperties().then(() => {
                setIsQuoting({ propertyId: val.id, campaignId: campaign.id });
            });
        });
    };

    const clearShowProperty = () => {
        setSelectedShow(undefined);
    };
    const onDeleteProperty = (d) => {
        DeleteCampaignProperty(d).then(() => {
            loadCampaignProperties();
        });
    };
    const [selectingProperty, setSelectingProperty] = useState(false);

    return (
        <div style={pageContainerStyle}>
            <Spacer height={20} />
            {isQuoting.propertyId && (
                <CreatePropertyOrders
                    campaign={campaign}
                    propertyId={isQuoting.propertyId}
                    done={() => setIsQuoting({})}
                />
            )}
            <CampaignPropertiesPanel
                campaignProperties={campaignProperties}
                onReserveProperty={handleReserve}
                campaign={campaign}
                readOnly={readOnly}
                onDeleteProperty={onDeleteProperty}
            />

            {!selectedShow ? (
                <ShowPanel campaign={campaign} onSelectShow={onSelectShowClick} />
            ) : (
                <ShowPropertiesPanel
                    show={selectedShow}
                    campaignProperties={campaignProperties}
                    onRequestClick={handleRequestClick}
                    onClose={clearShowProperty}
                    readOnly={readOnly}
                />
            )}
        </div>
    );
};

export default PropertySelection;
